import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
  @Input() privacyPolicyLink: string;
  @Input() termsOfUseLink: string;
  @Input() programFactsLink: string;
  @Input() oneTrustWebformLink: string;
}
